import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { contentApi } from "../../api/endpoints";

// İçerik yönetimi: namespace listesi (hangi locale'lerde dolu) + tek namespace+locale girişi + upsert.
export function useContentNamespaces() {
  return useQuery({
    queryKey: ["content", "namespaces"],
    queryFn: () => contentApi.adminList().then((r) => r.data),
  });
}

export function useContentEntry(page: string, locale: string) {
  return useQuery({
    queryKey: ["content", "entry", page, locale],
    queryFn: () => contentApi.getEntry(page, locale).then((r) => r.data),
    enabled: !!page && !!locale,
  });
}

export function useUpsertContent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      page,
      locale,
      data,
    }: {
      page: string;
      locale: string;
      data: Record<string, string>;
    }) => contentApi.upsert(page, locale, data).then((r) => r.data),
    onSuccess: (_res, { page, locale }) => {
      qc.invalidateQueries({ queryKey: ["content", "entry", page, locale] });
      qc.invalidateQueries({ queryKey: ["content", "namespaces"] });
    },
  });
}
